export default "__VITE_ASSET__BqCz6cgc__"